/**
 * E2E handles for the nav rows the suites drive. Keyed off the destination
 * rather than the item key so a row keeps its handle whichever nav
 * configuration contributed it.
 */
export const getSidebarNavTestId = (href: string): string | undefined => {
  if (href.includes("/uploaded")) {
    return "nav-uploaded"
  }
  if (href.includes("/simulated")) {
    return "nav-runs"
  }
  if (href.includes("/agents")) {
    return "nav-agents"
  }
  if (href.includes("/review")) {
    return "nav-human-review"
  }
  return undefined
}
